// Orientacao para criar modelos de Utilidade que a Meta nao reclassifique como Marketing.
// Regra oficial: Utilidade precisa ser especifica de algo que o cliente pediu ou fez,
// sem tom promocional. Apresentacao, divulgacao e retomada de contato sao Marketing.

function normalize(value) {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

// Termos que indicam referencia a uma acao do cliente (formulario, pedido, orcamento...).
const CUSTOMER_ACTION_TERMS = [
  'recebemos', 'solicitacao', 'solicitou', 'pedido', 'orcamento', 'cadastro', 'formulario',
  'agendamento', 'agendada', 'agendado', 'medicao', 'contrato', 'entrega', 'protocolo',
  'sua mensagem', 'seu contato', 'voce pediu', 'voce solicitou', 'confirmacao', 'confirmar',
];

// Termos tipicos de divulgacao ou retomada, que a Meta classifica como Marketing.
const MARKETING_TERMS = [
  'promocao', 'desconto', 'oferta', 'condicao especial', 'aproveite', 'conheca',
  'apresentar nossos', 'adorariamos', 'novidade', 'lancamento', 'ainda tem interesse',
  'podemos dar andamento', 'retomar', 'nao perca',
];

export function utilityTemplateWarnings(text) {
  const value = normalize(text);
  if (!value.trim()) return [];
  const warnings = [];
  if (!CUSTOMER_ACTION_TERMS.some((term) => value.includes(term))) {
    warnings.push('O texto não cita nenhuma solicitação ou ação do cliente (formulário, pedido, orçamento, agendamento...). Apresentações como "Sou a Elizabeth, como posso ajudar?" a Meta classifica como Marketing.');
  }
  const marketing = MARKETING_TERMS.filter((term) => value.includes(term));
  if (marketing.length) {
    warnings.push(`Termos de divulgação ou retomada de contato ("${marketing.join('", "')}") fazem a Meta classificar como Marketing, mesmo que o cliente tenha pedido.`);
  }
  return warnings;
}

export const UTILITY_GOOD_EXAMPLE = 'Bom dia! Sou a Elizabeth da Bazze PVC. Recebemos sua solicitação de orçamento pelo nosso formulário. Pode me enviar o projeto ou as medidas?';
export const UTILITY_BAD_EXAMPLE = 'Bom dia, tudo bem? Sou a Elizabeth da Bazze PVC. Como posso te ajudar?';
